import { render, staticRenderFns } from "./BaseSocialLinks.vue?vue&type=template&id=c15a0138&scoped=true"
import script from "./BaseSocialLinks.vue?vue&type=script&lang=js"
export * from "./BaseSocialLinks.vue?vue&type=script&lang=js"
import style0 from "./BaseSocialLinks.vue?vue&type=style&index=0&id=c15a0138&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c15a0138",
  null
  
)

export default component.exports